module.exports = new __parcel__URL__("Charlie_Text-Semibold_Italic.e87f5272.woff2").toString();